(function () {
  var COOKIE_NAME = 'bf_loading_screen_seen';

  function init() {
    var html = document.documentElement;
    var root = document.querySelector('[data-loading-screen]');
    if (!root) {
      html.classList.remove('loading-screen-pending');
      return;
    }
    // Comentado por pedido de Growth para manter o loading screen por seção
    // if (Cookies.get(COOKIE_NAME)) {
    //   root.remove();
    //   html.classList.remove('loading-screen-pending');
    //   return;
    // }

    var days = parseInt(root.dataset.cookieDays, 10) || 0;
    if (days > 0) {
      Cookies.set(COOKIE_NAME, 'true', { expires: days });
    } else {
      Cookies.set(COOKIE_NAME, 'true');
    }

    root.classList.add('loading-screen--visible');
    html.classList.add('loading-screen-lock');
    html.classList.remove('loading-screen-pending');

    var video = root.querySelector('video');
    if (video) {
      var showVideo = function () { video.classList.add('is-playing'); };
      if (!video.paused && video.readyState >= 3) showVideo();
      else video.addEventListener('playing', showVideo, { once: true });
    }

    var duration = (parseFloat(root.dataset.duration) || 3) * 1000;

    setTimeout(function () {
      root.classList.add('loading-screen--hide');
      document.documentElement.classList.remove('loading-screen-lock');
      root.addEventListener('transitionend', remove, { once: true });
      setTimeout(remove, 800);
    }, duration);

    function remove() {
      if (root && root.parentNode) root.remove();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
